import PubSub from "pubsub-js";
import optionsGridConfig from "../optionsGridConfig";
import { pubsubEvents } from "../../../../components/helpers/socket/pubsubEvent";
import config from "../../../../components/helpers/socket/config";
import { OrdersType } from "../../../../Constants";

/**
 * This is the main handler for received socket
 * messages that can be shared across your
 * widget content sandbox.
 *
 * The switch statement is intended to
 * match received actions to a dispatch event.
 */

export function cmed_options_grid_messageReceived(data) {
  if (data.status && (data.status === "ERROR" || data.status === "FAILURE")) {
    if (
      data.errors[0] !== pubsubEvents.errorMessage.REQUEST_ERROR_CMED_TIMEOUT &&
      data.errors[0] !==
        pubsubEvents.errorMessage.CMED_TOKEN_UNKNOWN_SQUARE_BRACKETS &&
      data.errors[0] !== pubsubEvents.errorMessage.CMED_TOKEN_UNKNOWN &&
      data.errors[0] !== pubsubEvents.errorMessage.ERROR_MESSAGE_GENERIC
    ) {
      switch (data.action) {
        case optionsGridConfig.socket.actions.CMED_UNDERLYING:
        case optionsGridConfig.socket.actions.CMED_OPTIONSGRID_EXPIRY:
        case optionsGridConfig.socket.actions
          .CMED_OPTIONSGRID_OPTION_GRID_EXPIRY:
        case optionsGridConfig.socket.actions.CMED_OPTIONSGRID_FIND_OPTIONS:
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
            data,
          );
          PubSub.publish(optionsGridConfig.socketKeys.CMED_OPTIONS_ERROR, data);
          break;
        case optionsGridConfig.socket.actions
          .CMED_OPTIONSGRID_SUBSCRIBE_STRIKELADDER:
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
            data,
          );
          PubSub.publish(
            optionsGridConfig.socketKeys.CMED_LADDER_SUBSCRIPTION_ERROR,
            data,
          );
          break;
        case config.socket.actions.CMED_ORDER_AGGRESSSION:
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
            data,
          );
          PubSub.publish(
            optionsGridConfig.socketKeys.CMED_ORDER_AGGRESSION_ERROR,
            data,
          );
          break;
        case config.socket.actions.CMED_ORDER_ENTRY:
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
            data,
          );
          PubSub.publish(
            optionsGridConfig.socketKeys.CMED_ORDER_ENTRY_ERROR,
            data,
          );
          break;
        default:
          break;
      }
    }
  } else {
    switch (data.action) {
      case optionsGridConfig.socket.actions.CMED_UNDERLYING:
        PubSub.publish(
          optionsGridConfig.socketKeys.CMED_UNDERLYING_SUCCESS,
          data,
        );
        break;
      case optionsGridConfig.socket.actions.CMED_OPTIONSGRID_EXPIRY:
        PubSub.publish(optionsGridConfig.socketKeys.CMED_EXPIRY_SUCCESS, data);
        break;
      case optionsGridConfig.socket.actions.CMED_OPTIONSGRID_FIND_OPTIONS:
        PubSub.publish(
          optionsGridConfig.socketKeys.CMED_FIND_OPTIONS_SUCCESS,
          data,
        );
        break;
      case config.socket.actions.CMED_ORDERS_SUBSCRIBE:
        if (data.type === OrdersType.OPTIONS_GRID_GROUP) {
          PubSub.publish(optionsGridConfig.socketKeys.CMED_ADD_CONTRACTS, data);
        }
        if (data.type === OrdersType.OPTIONS_GRID_GROUP_ITEM) {
          PubSub.publish(
            optionsGridConfig.socketKeys.CMED_ADD_CONTRACTS_LADDER,
            data,
          );
        }
        if (data.type === OrdersType.OPTIONS_GRID_GROUP_ITEM_DEPTH) {
          PubSub.publish(
            optionsGridConfig.socketKeys.CMED_SUPPLEMENTAL_DEPTH,
            data,
          );
        }
        break;
      case config.socket.actions.CMED_ORDER_CRITERIA:
        PubSub.publish(
          optionsGridConfig.socketKeys.CMED_OPTIONS_GRID_ORDER_CRITERIA,
          data,
        );
        break;
      case config.socket.actions.CMED_ITEM_PRICES:
        PubSub.publish(
          optionsGridConfig.socketKeys.CMED_OPTIONS_ITEM_PRICES,
          data,
        );
        break;
      case config.socket.actions.CMED_ORDER_ENTRY:
        PubSub.publish(optionsGridConfig.socketKeys.CMED_ORDER_ENTRY, data);
        break;
      case config.socket.actions.CMED_ORDER_AGGRESSSION:
        PubSub.publish(
          optionsGridConfig.socketKeys.CMED_ORDER_AGGRESSION,
          data,
        );
        break;
      default:
        console.log(`🔴 No matching type found for ${data.action}`);
        break;
    }
  }
  console.groupEnd();
}

// function eventListener() {
//   const listener = receive("cmed-service-message", (message) =>
//     messageReceived(message)
//   );
//   return listener;
// }

// export { eventListener as default };
